module.exports = __webpack_public_path__ + "static/affiliate/affiliate-square_ski-bro--chf-5e613034cb2fa7971de7409f9eb49538.webp";